import { Component, EventEmitter, Input, Output } from '@angular/core';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';
import {MarkdownComponent} from '../../../../../shared/components/markdown/markdown.component';


@Component({
  selector: 'app-group-header',
  standalone: true,
  imports: [
    AssetVersionPipe,
    MarkdownComponent
  ],
  templateUrl: './group-header.component.html',
  styleUrl: './group-header.component.scss',
})
export class GroupHeaderComponent {
  @Input({ required: true }) label!: string;

  @Input({ required: true }) groupId!: string;

  @Input() isFocused = false;

  @Output() findInChat = new EventEmitter<string>();

  onFindInChat(): void {
    this.findInChat.emit(this.groupId);
  }
}
